import type { JSX } from 'react';
import { Modal, ModalContent, ModalTitleInfo } from '@c2fo/liquidity';
import chartRotate from './chartRotate.svg?url';
import { QUOTE_LOADING_MODAL_CONTENT } from './content';

interface QuoteLoadingModalProps {
  open: boolean;
}

/**
 * Shown for the whole quotes POST. It is not a mode of the consent modal: that modal closes before
 * the request starts, and this one has nothing to acknowledge.
 *
 * `onClose` stays unset so Liquidity draws no close control and ignores Escape. The outside click is
 * ignored the same way.
 */
export const QuoteLoadingModal = ({ open }: QuoteLoadingModalProps): JSX.Element => (
  <Modal open={open} onClose={undefined} disableOutsideClickClose>
    <ModalTitleInfo>{QUOTE_LOADING_MODAL_CONTENT.title}</ModalTitleInfo>
    <ModalContent center>
      {/* Liquidity's Modal forwards no ARIA props, so the busy state sits on its content. */}
      <div aria-busy="true" className="flex flex-col items-center gap-4">
        <img src={chartRotate} alt="" className="size-[70px]" />
        <p>{QUOTE_LOADING_MODAL_CONTENT.body}</p>
      </div>
    </ModalContent>
  </Modal>
);
